<ng-template vdrDialogTitle>{{ "link.search-event" | translate }}</ng-template>

<div style="display: flex; width: 100%">
  <ng-select
    style="width: 100%"
    [items]="events$ | async"
    appendTo="body"
    bindLabel="name"
    [addTag]="false"
    [multiple]="true"
    [hideSelected]="true"
    [trackByFn]="trackByFn"
    [minTermLength]="2"
    [loading]="isLoading"
    [typeahead]="input$"
    [(ngModel)]="selectedEvent"
  >
    <ng-template ng-label-tmp let-item="item" let-clear="clear">
      <span class="item-row">
        <clr-icon shape="event" class="is-solid"></clr-icon
        ><span class="mx-1">{{ item.name }}</span>
      </span>
    </ng-template>
  </ng-select>

  <!-- <button
    style="margin-left: 1rem"
    type="button"
    class="btn btn-primary"
    (click)="createNewEvent()"
  >
    Create new event
  </button> -->
</div>

<ng-template vdrDialogButtons>
  <button type="button" class="btn" (click)="cancel()">
    {{ "common.cancel" | translate }}
  </button>
  <button type="submit" (click)="select()" class="btn btn-primary">
    {{ "common.okay" | translate }}
  </button>
</ng-template>
